export default "__VITE_ASSET__BpBoE4jl__"